const convertDate = (
  date,
  options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }
) => {
  return new Date(date).toLocaleDateString("en-US", options);
};

const formatPrice = (value) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(value);
};

export { convertDate, formatPrice };
